// extracted by mini-css-extract-plugin
export default {"pureCode":"MarkDownWrapper_pureCode__r-o5C","lang":"MarkDownWrapper_lang__wZgWy","copy":"MarkDownWrapper_copy__rZvG1","coupone":"MarkDownWrapper_coupone__FqPuX"};